export const HEARTBEAT_MS = 500;

export default function wait(fn: Function, freq: number = HEARTBEAT_MS): Promise<void> {
  return new Promise((resolve) =>
    (function heartbeat() {
      fn() ? resolve() : setTimeout(heartbeat, freq); // eslint-disable-line
    })()
  );
}
